import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CashHoldingLookup from "../Holdings/Models/Lookups/CashHoldingLookup";
import SecurityHoldingLookup from "../Holdings/Models/Lookups/SecurityHoldingLookup";
import HoldingSearchCriteria from "../Holdings/Models/Queries/SecurityHoldingSearchCriteria";

export interface IHoldingsApiClient {
    getSecurityHoldingPagedLists(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<HoldingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<SecurityHoldingLookup>>>;
    getCashHoldingPagedLists(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<HoldingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<CashHoldingLookup>>>;
}

@injectable()
export default class HoldingsApiClient extends Data.ApiClientBase implements IHoldingsApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/Holding`)
    }

    public getSecurityHoldingPagedLists(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<HoldingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<SecurityHoldingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetSecurityHoldingPagedLists?${Utils.getQueryString(payload)}`);
    }

    public getCashHoldingPagedLists(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<HoldingSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<CashHoldingLookup>>> {
        return this.axios.get(`${this.apiPath}/GetCashHoldingPagedLists?${Utils.getQueryString(payload)}`);
    }
}